import { isEmpty } from 'lodash';

export function checkIsError(searchData) {
  return !searchData?.struct || isEmpty(searchData.struct.components);
}
